/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {FragmentResult, Sequence as BioJSSequence} from 'BioJS';
import {Sequence} from 'components/Sequence';
import * as AssemblyConstants from 'constants/AssemblyConstants';
import {Strand} from 'constants/MolbioConstants';
import * as colors from 'lib/Colors';
import * as selectables from 'molbio/maps/selectables/Selectables';
import * as sequtil from 'molbio/SeqUtil';

const {ASSEMBLY_TYPE} = AssemblyConstants;

export class PrimerAssemblyMismatch extends selectables.RegionSelectable<Sequence> {
  start(): number {
    return this.get('pos');
  }
  end(): number {
    return this.get('pos') + 1;
  }
  uid(): string {
    return this.cid;
  }
  strand(): Strand {
    return 0;
  }

  click(sequence: Sequence): void {
    const selection = sequence.get('selection');
    selection.select(this);
  }
}

class PrimerAssemblyMismatches extends selectables.Collection<PrimerAssemblyMismatch> {
  static initClass(): void {
    this.prototype.model = PrimerAssemblyMismatch;
  }

  slice(start: number, end: number): Array<PrimerAssemblyMismatch> {
    return this.filter((mismatch) => sequtil.baseInRange(mismatch.get('pos'), start, end));
  }

  updateMismatches(_sequence: BioJSSequence): void {
    if (
      _sequence.finalized() ||
      _sequence.assemblyType() == null ||
      ![ASSEMBLY_TYPE.GIBSON, ASSEMBLY_TYPE.GOLDEN_GATE].includes(_sequence.assemblyType()!)
    ) {
      this.reset([]);
      return;
    }
    const bases = _sequence.bases();
    const mismatches = _sequence
      .fragmentResults()
      .chain()
      .map((fragmentResult: FragmentResult, fragmentResultIndex: number) => {
        const models = [];
        // Implies primerPairID non-null
        if (fragmentResult.primerFlanked()) {
          const seqLength = _sequence.length();
          const color = colors.shuffledPastelColors[fragmentResultIndex];
          const primerPair = _sequence.primerPairs().get(fragmentResult.primerPairID()!);
          const [fwd, rev] = Array.from(primerPair.getPrimers(_sequence.sequencePrimers()));
          const fwdDistance = sequtil.length(fragmentResult.start()!, fwd.end(), seqLength);
          const junction5 = fragmentResult.start();
          const junction3 = fragmentResult.end();
          const rawRevStart = sequtil.length(junction5!, rev.start(), seqLength);
          const revLength = sequtil.length(rev.start(), rev.end(), seqLength);
          const revStart =
            junction5 === rev.start() ? (revLength === seqLength ? rawRevStart : 0) : rawRevStart;
          const revEnd = sequtil.length(junction5!, junction3!, seqLength);

          for (const indices of [__range__(0, fwdDistance, false), __range__(revStart, revEnd, false)]) {
            for (const i of Array.from(indices)) {
              const index = sequtil.mod(fragmentResult.start()! + i, _sequence.length());
              if (
                (bases[index] != null ? bases[index].toLowerCase() : undefined) !==
                __guard__(fragmentResult.originalBases()![i], (x: string) => x.toLowerCase())
              ) {
                models.push(
                  new PrimerAssemblyMismatch({
                    pos: index,
                    fragmentSequenceID: __guard__(fragmentResult.parent(), (x1) => x1.id),
                    fragmentSequenceName: __guard__(fragmentResult.parent(), (x2) => x2.name),
                    fragmentResultColor: color,
                    originalBase: fragmentResult.originalBases()![i],
                    newBase: bases[index],
                  })
                );
              }
            }
          }
        }
        return models;
      })
      .flatten()
      .sortBy((m: PrimerAssemblyMismatch) => m.get('pos'))
      .value();
    this.reset(mismatches);
  }
}
PrimerAssemblyMismatches.initClass();

export default PrimerAssemblyMismatches;

function __range__(left: number, right: number, inclusive: boolean): Array<number> {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
function __guard__<T, S>(value: T | null, transform: (x: T) => S): S | undefined {
  return value != null ? transform(value) : undefined;
}
